
import { Alert, Button, Col, DatePicker, Form, Image, Input, InputNumber, List, Modal, Row, Select, Table, Tag, Upload } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import Search from 'antd/es/input/Search';
import { useSelector } from 'react-redux';
import moment from 'moment/moment';
import { currencyFormat } from '../../Utils/formatCurrency';
import { useNavigate } from 'react-router-dom';


function ServiceProcess() {
    const token = useSelector((state) => state.user.token);
    const navigate = useNavigate();
    //LIBRARY
    const [data, setData] = useState([]);
    const [statusService, setStatusService] = useState([]);
    const [courir, setCourir] = useState([]);
    const [sparepart, setSparepart] = useState([]);
    const [sparepartArr, setSparepartArr] = useState([]);
    const [valueStatusService, setValueStatusService] = useState(null);
    const [search, setSearch] = useState('');
    const [valueSparepart, setValueSparepart] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [load, setLoad] = useState(0);
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const [imageSparepart, setImageSparepart] = useState(null);
    const [video, setVideo] = useState(null);
    const [fileImageSparepart, setFileImageSparepart] = useState(null);
    const [fileVideo, setFileVideo] = useState(null);


    // //Parameter
    const titlePage = 'Produk Service';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            sorter: false,
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * 10 + index },
        },
        {
            title: 'Kode Tiket',
            dataIndex: 'CodeSC',
            key: "CodeSC",
            sorter: false,
        },
        {
            title: 'Foto Struk',
            dataIndex: 'ImageReceipt',
            key: "ImageReceipt",
            render: (text, record) => {
                return (
                    <>
                        <Image
                            width={80}
                            height={80}
                            src={record.ImageReceipt !== undefined ? record.ImageReceipt : null}
                            fallback="data:image/png;base64,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"
                        />
                    </>
                );
            },
        },
        {
            title: 'Foto Garansi',
            dataIndex: 'ImageGuarantee',
            key: "ImageGuarantee",
            render: (text, record) => {
                return (
                    <>
                        <Image
                            width={80}
                            height={80}
                            src={record.ImageGuarantee !== undefined ? record.ImageGuarantee : null}
                            fallback="data:image/png;base64,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"
                        />
                    </>
                );
            },
        },
        {
            title: 'Foto Produk',
            dataIndex: 'ProductImage',
            key: "ProductImage",
            render: (text, record) => {
                return (
                    <>
                        <Image
                            width={80}
                            height={80}
                            src={record.Product.ProductImage !== undefined ? record.Product.ProductImage : null}
                            fallback="data:image/png;base64,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"
                        />
                    </>
                );
            },
        },
        {
            title: 'Nama Produk',
            dataIndex: 'ProductName',
            key: "ProductName",
            sorter: false,
            render: (text, record) => {
                return record.Product.ProductName;
            }
        },
        {
            title: 'Nama Customer',
            dataIndex: 'Nama',
            key: "Nama",
            sorter: false,
            render: (text, record) => {
                return record.user.name;
            }
        },
        {
            title: 'Status Service',
            dataIndex: 'MS_StatusSC',
            key: "MS_StatusSC",
            sorter: false,
            render: (text, record) => {
                return <Tag>{record.MS_StatusSC.TitleStore}</Tag>;
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                        <Button style={{ marginRight: 10,marginBottom:10 }} onClick={() => navigate('/detailservice', { state: { item: record } })}>
                            <b style={{ marginLeft: 5 }}>Detail</b>
                        </Button>
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <b style={{ marginLeft: 5 }}>Ubah Status</b>
                        </Button>
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        getApi('GET', '/productservice?search=' + search + '&page=' + page.pagination.current, 'all');
        getApi('GET', '/statussc', 'sc');
        getApi('GET', '/sparepart?nopage=true', 'sparepart');
        getApi('GET', '/courir', 'courir');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), isAlert, load]);

    const getApi = async (method, url, type, data = null) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: data,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                switch (type) {
                    case 'all':
                        var item = res.data.rows;
                        setData(item);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.count
                            }
                        });
                        setLoading(false);
                        break;
                    case 'sc':
                        var item = res.data;
                        var row = [];
                        for (let i = 0; i < item.length; i++) {
                            row.push({
                                value: Number(item[i].StatusSCId),
                                label: item[i].TitleStore,
                            });
                        }
                        setStatusService(row);
                        setLoading(false);
                        break;
                    case 'courir':
                        var item = res.data;
                        var row = [];
                        for (let i = 0; i < item.length; i++) {
                            row.push({
                                value: Number(item[i].CourirId),
                                label: item[i].Name,
                            });
                        }
                        setCourir(row);
                        setLoading(false);
                        break;
                    case 'cek_sparepart':
                        var item = res.data;
                        var row = sparepartArr;
                        var status_add = true;
                        for (let i = 0; i < row.length; i++) {
                            if (Number(row[i].SparepartId) === valueSparepart) {
                                row[i].Qty += 1;
                                row[i].TotalPrice += Number(row[i].TotalPrice);
                                status_add = false;
                            }
                        }
                        if (status_add === true) {
                            row.push({
                                SparepartId: item.SparepartId,
                                SparepartCode: item.SparepartCode,
                                SerialNumber: item.SerialNumber,
                                Name: item.Name,
                                Price: item.Price,
                                Description: item.Description,
                                SparepartStore: item.SparepartStore,
                                SparepartAddress: item.SparepartAddress,
                                Qty: 1,
                                TotalPrice: Number(item.Price),
                            });
                        }
                        setSparepartArr(row);
                        setLoading(false);
                        break;
                    case 'sparepart':
                        var item = res.data.rows;
                        var row = [];
                        for (let i = 0; i < item.length; i++) {
                            row.push({
                                value: Number(item[i].SparepartId),
                                label: item[i].Name,
                            });
                        }
                        setSparepart(row);
                        setLoading(false);
                        break;
                    case 'insert':
                        setTextAlert(res.message);
                        setIsAlert(true);
                        closeModal();
                        setLoading(false);
                        break;
                    case 'update':
                        setTextAlert(res.message);
                        setIsAlert(true);
                        closeModal();
                        setLoading(false);
                        break;
                    case 'del':
                        setTextAlert(res.message);
                        setIsAlert(true);
                        closeModal();
                        setLoading(false);
                        setLoad(load + 1)
                        break;
                    default:
                        setTextAlert(res.message);
                        setIsAlert(true);
                        closeModal();
                        setLoading(false);
                        break;
                }
            } else {
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setLoad(load + 1);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    const openModal = async (type, data) => {
        if (type === 'edit') {
            setdataModal(data)
            setValueStatusService(Number(data.MS_StatusSC.StatusSCId));
            form.setFieldsValue({
                StatusSCId: Number(data.MS_StatusSC.StatusSCId),
                SparepartId: data.SparepartId,
                ResiAdmin:data.ResiAdmin,
                CourirIdAdmin:Number(data.CourirIdAdmin),
                ReasonCancelled:data.ReasonCancelled,
                PriceService:data.UserPayment !== null ? data.UserPayment.Price : null
            })
            var row = [];
            for (let i = 0; i < data.SubmissionSpareparts.length; i++) {
                var item = data.SubmissionSpareparts[i];
                row.push({
                    SparepartId: item.Sparepart.SparepartId,
                    SparepartCode: item.Sparepart.SparepartCode,
                    SerialNumber: item.Sparepart.SerialNumber,
                    Name: item.Sparepart.Name,
                    Price: item.Sparepart.Price,
                    Description: item.Sparepart.Description,
                    SparepartStore: item.Sparepart.SparepartStore,
                    SparepartAddress: item.Sparepart.SparepartAddress,
                    Qty: item.Qty,
                    TotalPrice: item.TotalPrice,
                });
            }
            setSparepartArr(row);
            setIsModal(true);
        } else {
            setIsModal(true);
        }
    }

    const onFinish = (ev) => {
        ev.SubmissionSCId = dataModal.SubmissionSCId;
        const form = new FormData();
        switch (Number(ev.StatusSCId)) {
            case 6:
                ev.sparepart = sparepartArr
                getApi('POST', '/productservicestatus', 'changestatus', ev);
                break;
            case 7:
                if (fileImageSparepart != null) {
                    ev.ImageSparepart = fileImageSparepart;
                }
                for (const name in ev) {
                    form.append(name, ev[name]);
                }
                getApi('POST', '/productservicestatus', 'changestatus', form);
                break;
            case 10:
                if (fileVideo != null) {
                    ev.VideoTesting = fileVideo;
                }
                for (const name in ev) {
                    form.append(name, ev[name]);
                }
                getApi('POST', '/productservicestatus', 'changestatus', form);
                break;

            default:
                getApi('POST', '/productservicestatus', 'changestatus', ev);
                break;
        }
    }

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        form.resetFields();
    }



    const uploadButton = (
        <div>
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </div>
    );

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };
    const uploadImage = (info, type) => {
        switch (type) {
            case 'sparepart':
                setFileImageSparepart(info.file);
                getBase64(info.file, (url) => {
                    setImageSparepart(url);
                });
                break;
            case 'video':
                setFileVideo(info.file);
                getBase64(info.file, (url) => {
                    setVideo(url);
                });
                break;

            default:
                break;
        }
    };

    const addArrSparepart = () => {
        getApi('GET', '/sparepart/' + valueSparepart, 'cek_sparepart');
    }

    const delArrSparepart = (index) => {
        var row = sparepartArr;
        row.splice(index, 1);
        setSparepartArr(row);
        setLoad(load + 1)
    }

    return (
        <>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Daftar Produk Service</h3>
            <Row style={{ marginBottom: 10 }}>
                <Col span={8}>
                    <Search
                        placeholder="Pencarian"
                        allowClear
                        enterButton="Search"
                        size="medium"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />

            <Modal title="Form Produk Service" open={isModal} onOk={form.submit} onCancel={() => closeModal()} okText="Simpan" >
                {
                    dataModal !== null &&
                    <>
                        <h2>{dataModal.CodeSC}</h2>
                        <table>
                            <tr>
                                <td>Nama Customer</td>
                                <td> : </td>
                                <td>{dataModal.user.name}</td>
                            </tr>
                            <tr>
                                <td>Nama Produk</td>
                                <td> : </td>
                                <td>{dataModal.Product.ProductName}</td>
                            </tr>
                            <tr>
                                <td>Serial Number</td>
                                <td> : </td>
                                <td>{dataModal.SerialNumber}</td>
                            </tr>
                            <tr>
                                <td>Tanggal Pembelian</td>
                                <td> : </td>
                                <td>{dataModal.PurchaseDate}</td>
                            </tr>
                            <tr>
                                <td>Video</td>
                                <td> : </td>
                                <td>{dataModal.Video !== null ? <a href={dataModal.Video} >Link Video</a> : 'Tidak ada Video'}</td>
                            </tr>
                        </table>
                        <br />
                        <Form form={form} name="form" layout="vertical" onFinish={onFinish}>
                            <Form.Item
                                name="StatusSCId"
                                label="Pilih Status Service"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Pilih Status Service kosong!'
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                                    // filterOption={(inputValue, option) =>
                                    //   option.children.join('').toLowerCase().includes(inputValue.toLowerCase())
                                    // }
                                    onChange={(ev) => setValueStatusService(ev)}
                                    // filterSort={(optionA, optionB) =>
                                    //     (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    // }
                                    options={statusService}
                                />
                            </Form.Item>
                            {
                                valueStatusService === 1 &&
                                <>
                                    <Form.Item
                                        name="PriceService"
                                        label="Harga Servis"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Harga Servis kosong!'
                                            },
                                        ]}
                                    >
                                    <InputNumber
                                        style={{width:'100%'}}
                                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                    />
                                    </Form.Item>
                                </>
                            }
                            {
                                valueStatusService === 6 &&
                                <>
                                    <Form.Item
                                        name="SparepartId"
                                        label="Pilih Sparepart"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Pilih Sparepart kosong!'
                                            },
                                        ]}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={(ev) => setValueSparepart(ev)}
                                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                                            filterSort={(optionA, optionB) =>
                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                            }

                                            options={sparepart}
                                        />
                                    </Form.Item>
                                    <Button onClick={() => addArrSparepart()}>Tambah Sparepart</Button>
                                    {
                                        sparepartArr.length > 0 &&
                                        <List
                                            itemLayout="horizontal"
                                            dataSource={sparepartArr}
                                            renderItem={(item, index) => (
                                                <List.Item>
                                                    <List.Item.Meta
                                                        title={item.Name + ' ' + item.Qty + 'x'}
                                                        description={item.Description}
                                                    />
                                                    <p style={{ fontSize: 12, color: '#FF4500' }}>{currencyFormat(Number(item.TotalPrice))}</p>
                                                    <Button danger style={{ marginLeft: 10 }} onClick={() => delArrSparepart(index)}>Hapus</Button>

                                                </List.Item>
                                            )}
                                        />
                                    }
                                </>
                            }
                            {
                                valueStatusService === 7 &&
                                <Form.Item
                                    name="ImageSparepart"
                                    label="Foto Sparepart"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Sparepart kosong!'
                                        },
                                    ]}
                                >
                                    <Upload
                                        listType="picture-card"
                                        showUploadList={false}
                                        onChange={(ev) => uploadImage(ev, 'sparepart')}
                                        beforeUpload={() => false}
                                    >
                                        {imageSparepart ? (
                                            <p style={{ fontSize: 10 }}>{fileImageSparepart.name}</p>
                                        ) : (
                                            uploadButton
                                        )}
                                    </Upload>
                                    {dataModal.ImageSparepart !== null && <Tag color='green'>file sudah terupload<br /> {dataModal.ImageSparepart}</Tag>}
                                </Form.Item>
                            }
                            {
                                valueStatusService === 10 &&
                                <Form.Item
                                    name="VideoTesting"
                                    label="Video Testing"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Video Testing kosong!'
                                        },
                                    ]}
                                >
                                    <Upload
                                        listType="picture-card"
                                        showUploadList={false}
                                        onChange={(ev) => uploadImage(ev, 'video')}
                                        beforeUpload={() => false}
                                    >
                                        {video ? (
                                            <p style={{ fontSize: 10 }}>{fileVideo.name}</p>
                                        ) : (
                                            uploadButton
                                        )}
                                    </Upload>
                                </Form.Item>
                            }
                            {
                                valueStatusService === 13 &&
                                <>
                                <Form.Item
                                    name="ResiAdmin"
                                    label="Nomor Resi"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Nomor Resi kosong!'
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    name="CourirIdAdmin"
                                    label="Pengiriman Via"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Pengiriman Via kosong!'
                                        },
                                    ]}
                                >
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                                    // filterOption={(inputValue, option) =>
                                    //   option.children.join('').toLowerCase().includes(inputValue.toLowerCase())
                                    // }
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    options={courir}
                                />
                                </Form.Item>
                                </>
                            }
                            {
                                valueStatusService === 15 &&
                                <Form.Item
                                    name="ReasonCancelled"
                                    label="Alasan Dibatalkan"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Alasan dibatalkan kosong!'
                                        },
                                    ]}
                                >
                                    <Input.TextArea />
                                </Form.Item>
                            }
                        </Form>
                    </>
                }
            </Modal>

        </>
    );
}

export default ServiceProcess;